export default __webpack_public_path__ + "static/media/github.ac9cbde4.svg";